import type { ResolverMap } from './ResolverMap'
import type { TranslateFn } from './TranslateFn'
import { resolveCode } from './resolveCode'
import type { NavMenuCode } from './NavMenuCode'

const navMenuByCode = {
  DASHBOARD: 'presentation.navMenu.dashboard',
  ORDERS: 'presentation.navMenu.orders',
  ORDERS_CUSTOMER: 'presentation.navMenu.ordersCustomer',
  PAYOUTS: 'presentation.navMenu.payouts',
  PAYMENTS: 'presentation.navMenu.payments',
  REPORTS: 'presentation.navMenu.reports',
  BRANDS: 'presentation.navMenu.brands',
  STORES: 'presentation.navMenu.stores',
  REVIEWS: 'presentation.navMenu.reviews',
  REVIEWS_CUSTOMER: 'presentation.navMenu.reviewsCustomer',
  FAVORITES: 'presentation.navMenu.favorites',
  MENUS: 'presentation.navMenu.menus',
  USERS: 'presentation.navMenu.users',
  PROFILE: 'presentation.navMenu.profile',
  SETTINGS: 'presentation.navMenu.settings'
} satisfies Record<NavMenuCode, string>

const navMenuResolverMap: ResolverMap<NavMenuCode> = {
  byCode: navMenuByCode,
  byReason: {},
  genericKey: 'presentation.navMenu.generic'
}

function isNavMenuCode(code: string): code is NavMenuCode {
  return Object.hasOwn(navMenuByCode, code)
}

export function resolveNavMenuLabel(code: string, t: TranslateFn): string {
  if (!isNavMenuCode(code)) return t('presentation.navMenu.generic')
  return resolveCode({ code }, navMenuResolverMap, t)
}
